<script>
export default {
  data() {
    return {
      title: "Settings",
      text: "Customer",
      text1: "Settings",
    };
  },
};
</script>
<template>
  <layout-header></layout-header>
  <!-- Breadcrumb -->
  <page-breadcrumb :title="title" :text="text" :text1="text1" />
  <!-- /Breadcrumb -->
  <!-- Page Wrapper -->
  <div class="page-wrapper">
    <div class="content">
      <div class="container">
        <div class="row justify-content-center">
          <div class="col-xl-3 col-lg-4">
            <customer-sidebar></customer-sidebar>
          </div>
          <div class="col-xl-9 col-lg-8">
            <h4 class="mb-3">Security Settings</h4>
            <div class="row justify-content-center align-items-center">
              <div class="col-xxl-4 col-md-6">
                <div class="card dash-widget-2">
                  <div class="card-body">
                    <div class="d-flex align-items-center mb-3">
                      <span
                        class="set-icon bg-light d-flex justify-content-center align-items-center rounded-circle p-1 me-2"
                      >
                        <i class="ti ti-lock text-dark fs-20"></i>
                      </span>
                      <div>
                        <p class="mb-0 text-gray-9 fw-medium">Password</p>
                        <span class="fs-12 text-truncate"
                          >Last Changed :
                          <span class="text-gray-9">22 Jul 2024, 10:30:55 AM</span></span
                        >
                      </div>
                    </div>
                    <a
                      href="javascript:void(0);"
                      class="btn btn-dark"
                      data-bs-toggle="modal"
                      data-bs-target="#change-password"
                      >Change Password</a
                    >
                  </div>
                </div>
              </div>
              <div class="col-xxl-4 col-md-6">
                <div class="card dash-widget-2">
                  <div class="card-body">
                    <div class="d-flex align-items-center mb-3">
                      <span
                        class="set-icon bg-light d-flex justify-content-center align-items-center rounded-circle p-1 me-2"
                      >
                        <i class="ti ti-fingerprint-scan text-dark fs-20"></i>
                      </span>
                      <div class="sec-item row align-items-center">
                        <div class="col-lg-9 col-md-9 d-flex">
                          <div>
                            <h6 class="fs-16 mb-2">Two Factor</h6>
                            <p class="text-gray fs-12 text-truncate">
                              Strengthens security with an extra step.
                            </p>
                          </div>
                        </div>
                        <div class="col-lg-3 col-md-3 d-flex">
                          <div
                            class="d-flex align-items-center justify-content-end form-check form-switch text-end mb-3"
                          >
                            <input
                              type="checkbox"
                              id="status-two"
                              class="form-check-input"
                            />
                          </div>
                        </div>
                      </div>
                    </div>
                    <a href="javascript:void(0);" class="btn btn-dark">Disable</a>
                  </div>
                </div>
              </div>
              <div class="col-xxl-4 col-md-6">
                <div class="card dash-widget-2">
                  <div class="card-body">
                    <div class="d-flex align-items-center mb-3">
                      <span
                        class="set-icon bg-light d-flex justify-content-center align-items-center rounded-circle p-1"
                      >
                        <i class="ti ti-device-mobile text-dark fs-20"></i>
                      </span>
                      <div class="ms-2">
                        <div class="d-flex">
                          <p class="mb-0 text-gray-9 text-truncatefw-medium me-1">
                            Phone Number Verification
                          </p>
                          <span
                            class="set-icon-2 badge badge-success d-flex justify-content-center align-items-center rounded-circle"
                            ><i class="ti ti-check"></i
                          ></span>
                        </div>
                        <span class="fs-12"
                          >Verified Mobile Number :<span class="text-gray-9"
                            >+99264710583</span
                          ></span
                        >
                      </div>
                    </div>
                    <div class="d-flex align-items-center">
                      <a
                        href="javascript:void(0);"
                        class="btn btn-dark me-2"
                        data-bs-toggle="modal"
                        data-bs-target="#change-phone"
                        >Change</a
                      >
                      <a
                        href="javascript:void(0);"
                        class="btn btn-light"
                        data-bs-toggle="modal"
                        data-bs-target="#del-account"
                        >Remove</a
                      >
                    </div>
                  </div>
                </div>
              </div>
              <div class="col-xxl-4 col-md-6">
                <div class="card dash-widget-2">
                  <div class="card-body">
                    <div class="d-flex align-items-center mb-3">
                      <span
                        class="set-icon bg-light d-flex justify-content-center align-items-center rounded-circle p-1"
                      >
                        <i class="ti ti-mail text-dark fs-20"></i>
                      </span>
                      <div class="ms-2">
                        <div class="d-flex">
                          <p class="mb-0 text-gray-9 fw-medium me-1">
                            Email Verification
                          </p>
                          <span
                            class="set-icon-2 badge badge-success d-flex justify-content-center align-items-center rounded-circle"
                            ><i class="ti ti-check"></i
                          ></span>
                        </div>
                        <span class="fs-12 text-truncate"
                          >Verified Email :<span class="text-gray-9"
                            >info@example.com</span
                          ></span
                        >
                      </div>
                    </div>
                    <div class="d-flex align-items-center">
                      <a
                        href="javascript:void(0);"
                        class="btn btn-dark me-2"
                        data-bs-toggle="modal"
                        data-bs-target="#change-email"
                        >Change</a
                      >
                      <a
                        href="javascript:void(0);"
                        class="btn btn-light"
                        data-bs-toggle="modal"
                        data-bs-target="#del-account"
                        >Remove</a
                      >
                    </div>
                  </div>
                </div>
              </div>
              <div class="col-xxl-4 col-md-6">
                <div class="card dash-widget-2">
                  <div class="card-body">
                    <div class="d-flex align-items-center mb-3">
                      <span
                        class="set-icon bg-light d-flex justify-content-center align-items-center rounded-circle p-1 me-2"
                      >
                        <i class="ti ti-device-imac text-dark fs-20"></i>
                      </span>
                      <div>
                        <p class="mb-0 text-gray-9 fw-medium">Device Management</p>
                        <span class="fs-12 text-truncate"
                          >Last Changed :
                          <span class="text-gray-9">22 Jul 2024, 10:30:55 AM</span></span
                        >
                      </div>
                    </div>
                    <router-link to="/customer-settings/device-managment" class="btn btn-dark"
                      >Manage</router-link
                    >
                  </div>
                </div>
              </div>
              <div class="col-xxl-4 col-md-6">
                <div class="card dash-widget-2">
                  <div class="card-body">
                    <div class="d-flex align-items-center mb-3">
                      <span
                        class="set-icon bg-light d-flex justify-content-center align-items-center rounded-circle p-1 me-2"
                      >
                        <i class="ti ti-user-edit text-dark fs-20"></i>
                      </span>
                      <div>
                        <p class="mb-0 text-gray-9 fw-medium">Account Activity</p>
                        <span class="fs-12 text-truncate"
                          >Last Changed :
                          <span class="text-gray-9">22 Jul 2024, 10:30:55 AM</span></span
                        >
                      </div>
                    </div>
                    <router-link to="/customer-settings/login-activity" class="btn btn-dark"
                      >View All</router-link
                    >
                  </div>
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>
    </div>
  </div>
  <!-- /Page Wrapper -->
  <pages-footer></pages-footer>
  <security-settings-modal></security-settings-modal>
</template>
